"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeStyles = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */
var makeSizeStyles = function makeSizeStyles(size) {
  var value = (0, _rem.default)(size);
  return {
    width: value,
    minWidth: value,
    height: value,
    minHeight: value
  };
};

var sizeStyles = {
  'small.square': makeSizeStyles(20),
  'medium.round': makeSizeStyles(36),
  'medium.square': makeSizeStyles(30),
  'large.round': makeSizeStyles(60)
};
exports.sizeStyles = sizeStyles;